// extracted by mini-css-extract-plugin
module.exports = {"icon":"CopyButton_icon__hcGLC"};